import { LogType } from '../../../../Types/Enums';
import useLogFiles from '../../../../Hooks/useCompliance';

interface LogEntry {
    action: string;
    agent: string;
    data: any;
    date: string;
    previousHash: string | null;
}

function findIndexes(words: string[], text: string) {
    for (const word of words) {
        const index = text.indexOf(word);
        if (index !== -1) {
            return { word, start: index, end: index + word.length - 1 };
        }
    }
    return null;
}

const LOG_TYPES = ['DEBUG', 'INFO', 'NOTICE', 'WARNING', 'ERROR', 'CRITICAL', 'ALERT', 'EMERGENCY'];
const LOG_TYPE_COLORS: { [key: string]: string } = {
    DEBUG: 'initial',
    INFO: 'blue',
    NOTICE: 'blue',
    WARNING: '#ffcc00',
    ERROR: 'red',
    CRITICAL: 'red',
    ALERT: '#ffcc00',
    EMERGENCY: '#ffcc00',
};

function LogLine(props: { event: { lineCount: number; payload: string }; isActionLogger: boolean; id?: string }) {
    const { toLocalDateTime } = useLogFiles({ initialLogType: LogType.Scim });

    if (props.isActionLogger && props.event.payload.length) {
        const payload: LogEntry = JSON.parse(props.event.payload);
        const dataStr = JSON.stringify(payload.data);
        return (
            <div id={props.id} className="my-3" style={{ display: 'flex', justifyContent: 'space-between' }}>
                <div>
                    {props.event.lineCount}&nbsp;
                    {toLocalDateTime(payload.date)}&nbsp;
                    <strong style={{ color: 'initial' }}>{payload.action.toUpperCase()}</strong>&nbsp;
                    {payload.agent} {payload.previousHash ?? 'null'}&nbsp;
                    {dataStr}
                </div>
            </div>
        );
    }

    const found = findIndexes(LOG_TYPES, props.event.payload);
    return (
        <div id={props.id} style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div>
                {props.event.lineCount}&nbsp;
                {found == null ? (
                    props.event.payload
                ) : (
                    <>
                        {props.event.payload.slice(0, found.start)}
                        <strong style={{ color: LOG_TYPE_COLORS[found.word] }}>
                            {props.event.payload.slice(found.start, found.end + 1)}
                        </strong>
                        {props.event.payload.slice(found.end + 1)}
                    </>
                )}
            </div>
        </div>
    );
}

export default LogLine;
